
export enum ImageSource {
    Pexels = 1,
    Pixabay = 2,
    Unsplash = 3,
    Search = 4,
}